import { parseIndustriesMapping } from 'shared/parsers';

export let industriesMapping = {}; // eslint-disable-line import/no-mutable-exports

export const setIndustriesMapping = industries => {
  industriesMapping = parseIndustriesMapping(industries);
};
